import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EnrolledUserItem } from "../types";

interface UseEnrolledUsersListArgs {
  corporateId: string | number;
  objectId: number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const ENROLLED_STATUS = "E,C,P,T";

export const useEnrolledUsersList = ({
  corporateId,
  objectId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseEnrolledUsersListArgs): PaginatedListResult<EnrolledUserItem> => {
  const url = corporateId
    ? `${ServicesURL.getEnrollment}?corporateId=${corporateId}&objectId=${objectId}`
    : null;

  return usePaginatedList<EnrolledUserItem>(
    url,
    {
      page,
      pageSize,
      search,
      fieldFilters: { status: ENROLLED_STATUS, ...(fieldFilters || {}) },
    },
    {
      responseKey: "enrollmentResponses",
      totalElementsKey: "totalElements",
      totalPagesKey: "totalPages",
    },
  );
};
